<h1 mat-dialog-title class="dialog-title-container">
  Sites Information
</h1>
<button mat-icon-button class="close-icon" (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content class="custom-dialog-content">
  <div class="table-container um-table-wrap">
    <table mat-table [dataSource]="dataSource" class="mat-table um-table">
       
         <ng-container matColumnDef="id">
            <th class="left-sorted-header" mat-header-cell *matHeaderCellDef> Id </th>
            <td class="left-sorted-header" mat-cell *matCellDef="let element; let i= index;"> {{i+1}} </td>
          </ng-container>
      
    <ng-container matColumnDef="potentialName">
        <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef> Potential Name </th>
        <td class="centered-sorted-header" mat-cell *matCellDef="let element"> {{element.potentialName}} </td>
      </ng-container>
  
      <!-- Potential ID Column -->
      <ng-container matColumnDef="potentialId">
        <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef> Potential ID </th>
        <td class="centered-sorted-header" mat-cell *matCellDef="let element"> {{element.potentialId}} </td>
      </ng-container>
  
      <!-- Site Type Column -->
      <ng-container matColumnDef="siteType">
        <th  class="right-sorted-header" mat-header-cell *matHeaderCellDef> Site Type </th>
        <td  class="right-sorted-header" mat-cell *matCellDef="let element"> {{element.siteType}} </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  </div>
